import { createAppAsyncThunk } from '../../store/extensions';
import { UpdateJournalDto, CreateJournalDto } from './dtos';
import {
  fetchJournalsCall,
  createJournalCall,
  deleteJournalCall,
  updateJournalCall,
} from './service';

export const fetchJournals = createAppAsyncThunk(
  'healthJourney/getJournals',
  (healthJourneyId: string) => {
    return fetchJournalsCall(healthJourneyId);
  }
);

export const createJournal = createAppAsyncThunk(
  'healthJourney/createJournal',
  (newJournal: CreateJournalDto) => {
    return createJournalCall(newJournal);
  }
);

export const deleteJournal = createAppAsyncThunk(
  'healthJourney/deleteJournals',
  (journalId: string) => {
    return deleteJournalCall(journalId);
  }
);

export const updateJournal = createAppAsyncThunk(
  'healthJourney/updateJournal',
  (journal: UpdateJournalDto) => {
    return updateJournalCall(journal);
  }
);
